import * as React from 'react';

import { Link } from '@coursera/cds-core';

import _t from 'i18n!nls/career-plans';

import 'css!./__styles__/CareerPlans404';

const CareerPlans404 = () => (
  <div className="rc-CareerPlans404">
    <div className="bt3-container">
      <h1 className="headline-5-text">{_t('Sorry')}</h1>

      <p className="headline-2-text">
        {_t("We couldn't find the career plan that you're looking for.")}

        <span>&nbsp;</span>
        <Link href="/browse">{_t('Browse catalog')}</Link>
      </p>
    </div>
  </div>
);

export default CareerPlans404;
